import moment from "moment";
import customToDoListIdsRepository from "../repositories/customToDoListIdsRepository";
import toDoListRepository from "../repositories/toDoListRepository";

const {
  normalizeCustomListIds,
  activeCustomLists,
  withArchived,
  withRestored,
  partitionListsForReorder,
} = require("./customListArchive.js");
const { logListActivity } = require("./todoActivityLog.js");

/**
 * Create a custom to-do list (same path as desktop sidebar).
 * @param {import('vuex').Store} store
 * @returns {{ listId: string, listName: string, archived: boolean, archivedAt: null }}
 */
export function createCustomTodoList(store) {
  const customTodoListId = {
    listId: moment().format("YYYYMMDDTHHmmssS"),
    listName: "",
    archived: false,
    archivedAt: null,
  };
  store.commit("actionsCListCreatedUpdate", true);
  store.commit("newCustomTodoList", customTodoListId);
  customToDoListIdsRepository.update(store.getters.cTodoListIds);
  toDoListRepository.update(
    customTodoListId.listId,
    store.getters.todoLists[customTodoListId.listId]
  );
  return customTodoListId;
}

function persistDirectory(store, next) {
  store.commit("loadCustomTodoListsIds", next);
  customToDoListIdsRepository.update(store.getters.cTodoListIds);
}

function fireListActivity(type, listId, listName, { t, createNoteFn } = {}) {
  if (!t || !createNoteFn) return;
  const pending = logListActivity({
    type,
    listId,
    listName: listName || listId,
    t,
    createNoteFn,
  });
  if (pending && typeof pending.then === "function") {
    pending.then(
      () => {},
      () => {}
    );
  }
}

/**
 * Archive a custom list. Returns the updated entry or null.
 */
export function archiveCustomTodoList(store, listId, opts = {}) {
  const all = normalizeCustomListIds(store.getters.cTodoListIds);
  const cur = all.find((e) => e.listId === listId);
  if (!cur || cur.archived) return null;
  const nextEntry = withArchived(cur, moment().format("YYYYMMDDTHHmmss"));
  const next = all.map((e) => (e.listId === listId ? nextEntry : e));
  persistDirectory(store, next);
  fireListActivity("list_archived", listId, nextEntry.listName, opts);
  return nextEntry;
}

/**
 * Restore an archived list to the end of the active block.
 */
export function restoreCustomTodoList(store, listId, opts = {}) {
  const all = normalizeCustomListIds(store.getters.cTodoListIds);
  const cur = all.find((e) => e.listId === listId);
  if (!cur || !cur.archived) return null;
  const restored = withRestored(cur);
  const without = all.map((e) => (e.listId === listId ? restored : e));
  const activeIds = activeCustomLists(without)
    .filter((e) => e.listId !== listId)
    .map((e) => e.listId);
  activeIds.push(listId);
  const next = partitionListsForReorder(without, activeIds);
  persistDirectory(store, next);
  fireListActivity("list_restored", listId, restored.listName, opts);
  return restored;
}
